import moment from 'moment';
import {
  SET_ITEMS,
  SET_TOTAL,
  SET_CRITERE_RECHERCHE,
  SET_LAST_PAYLOAD,
} from '@/store/modules/produitReseauTempo-mutation-type';
import * as allTypes from '@/store/mutation-type';
import { getAllType } from '@/api/produit/produitReseau';
import { getAllPlanning } from '@/api/dispo';
import genererCritereRecherche
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauTempo';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';

export function initialState() {
  return {
    items: [],
    total: 0,
    criteresRecherche: genererCritereRecherche(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduits({ commit }, data) {
    commit(SET_LAST_PAYLOAD, data);
    const result = await getAllType(data);
    let allDipos = [];
    if (data.query?.categories.length === 0
      || data.query?.categories?.includes(CATEGORIE_REGROUPEMENT)) {
      const dateDebut = moment(data.query.dateVisualisation).startOf('week').toDate();
      const dateFin = moment(data.query.dateVisualisation).endOf('week').toDate();
      if (result.data.result.totalCount > 0) {
        allDipos = (await getAllPlanning(result.data.result.items.map((reseauTempo) => {
          return reseauTempo.id;
        }), dateDebut, dateFin)).data.result;
      }
    }
    result.data.result.items.forEach((produitReseau) => {
      produitReseau.selected = false;
      if (produitReseau?.supportCommercial?.categorieVente === CATEGORIE_REGROUPEMENT) {
        produitReseau.nbFacesPrevues = 0;
        const dispoFind = allDipos[produitReseau.id];
        dispoFind.forEach((dispo) => {
          produitReseau.nbFacesPrevues += dispo.stock;
        });
      } else {
        produitReseau.nbFacesPrevues = produitReseau?.produitReseau?.quantiteFaces ?? 0;
      }
    });
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
